import { useEffect, useRef } from 'react';
import { uploadOutcomeChannel } from '../../domain/services/upload/upload.outcome.channel';

export default function useUploadOutcome(requestId, apply) {
    const mounted = useRef(true);
    const latestApply = useRef(apply);
    latestApply.current = apply;

    useEffect(() => {
        mounted.current = true;
        const stop = requestId ? uploadOutcomeChannel.listen(requestId, outcome => latestApply.current(outcome)) : () => undefined;
        return () => {
            mounted.current = false;
            stop();
        };
    }, [requestId]);

    return (outcome) => {
        if (mounted.current || !requestId) return latestApply.current(outcome);
        return uploadOutcomeChannel.deliver(requestId, outcome);
    };
}
